import * as React from 'react';

// components
import Forbidden from 'pages/Forbidden';

// stores
import { useStores } from 'index';
import { ApplicationUserRights } from 'stores/ApplicationUserRightsStore';

// types
import { Feature, License } from 'types/ProfileTypes';
import { IProfileStore } from 'stores/ProfileStore';

export const isUserAllowedToAccessPage = (
  profileStore: IProfileStore,
  requiredPermissions: string[] | string,
  requiredLicenses?: License[] | License,
  requiredFeatures?: Feature[] | Feature
) => {
  const hasRequiredLicenses = profileStore.HasAnyLicenseOf(requiredLicenses);
  const hasRequiredFeatures = profileStore.HasAnyFeatureOf(requiredFeatures);

  return ApplicationUserRights.IsAllowed(requiredPermissions) && (hasRequiredLicenses || hasRequiredFeatures);
};

export const Authorization = (
  WrappedComponent: any,
  requiredPermissions: string[] | string,
  requiredLicenses?: License[] | License,
  requiredFeatures?: Feature[] | Feature
) => {
  const WithAuthorization: React.FC = (props) => {
    const { profileStore } = useStores();

    if (isUserAllowedToAccessPage(profileStore, requiredPermissions, requiredLicenses, requiredFeatures)) {
      return <WrappedComponent {...props} />;
    } else {
      return <Forbidden />;
    }
  };

  return WithAuthorization;
};
